/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import { useMutation } from '@apollo/client' // Npm: Apollo client for handling graphql request.
import { useToast } from '@chakra-ui/react' // Npm: Chakra UI toast component.
import { useSelector } from 'react-redux' // Npm: Redux selector hook.


/*
 * PACKAGES
 */
import SystemCard from 'components/SystemCard'
import RestartConfirmationModal from 'components/RestartConfirmationModal'


/*
 * GRAPHS
 */
import RestartServerMutation from './__mutation__/index.nodeserver.restart'


/*
 * COMPONENT
 */
const NodeServerInfo = () => {
  // Hook assignment.
  const toast = useToast()
  const [modalOpen, setModalOpen] = React.useState(false)

  // Get data from Redux store instead of subscription.
  const { data: nodeServerData, error: nodeServerError, loading: isLoading } = useSelector(
    (state) => state.SystemInfo.local
  )

  // Mutation to restart Node server.
  const [MutationRestartNodeServer, MutationRestartNodeServerResponse] = useMutation(
    RestartServerMutation,
    {
      'onCompleted': (res) => {
        // Check if restart was successful.
        const success = res?.RestartServer?.success
        toast({
          'title': success ? 'Node Server Restarted' : 'Restart Failed',
          'description': res?.RestartServer?.message || '',
          'status': success ? 'success' : 'error',
          'duration': 4000,
          'isClosable': true,
        })
      },
      'onError': (error) => {
        // Show error toast.
        toast({
          'title': 'Node Server restart failed',
          'description': error.message,
          'status': 'error',
          'duration': 4000,
          'isClosable': true,
        })
      },
    }
  )

  // Modal handlers.
  const openModal = React.useCallback(() => setModalOpen(true), [])
  const closeModal = React.useCallback(() => setModalOpen(false), [])
  const handleConfirmRestart = React.useCallback(() => {
    closeModal()
    MutationRestartNodeServer()
  }, [closeModal, MutationRestartNodeServer])

  // Return component.
  return (
    <>
      <SystemCard
        title="Node Server"
        data={nodeServerData}
        serverType="node"
        onRestart={openModal}
        isRestarting={MutationRestartNodeServerResponse.loading}
        fetchError={nodeServerError}
        isFetching={isLoading}
      />

      <RestartConfirmationModal
        isOpen={modalOpen}
        onClose={closeModal}
        onConfirm={handleConfirmRestart}
        message="Are you sure you want to restart the Node server?"
      />
    </>
  )
}


/*
 * EXPORTS
 */
export default NodeServerInfo
